/* eslint-disable react/prop-types */
import React from 'react';
import { Spin, Tooltip } from 'antd';

/**
 * Insights briefs sidebar — same shell/titles pattern as chat history.
 * Title only differs (no duplicate Ask Evans brand).
 */
const SpacerLogAiInsightsSidebar = ({
  features = [],
  activeFeature = null,
  loading = false,
  onSelect,
}) => (
  <aside className="spacer-ask-evans__sidebar" aria-label="Insight briefs">
    <div className="spacer-ask-evans__sidebar-head">
      <h2 className="spacer-ask-evans__sidebar-title">Insights</h2>
      <p className="spacer-ask-evans__sidebar-sub">Your insight briefs</p>
    </div>

    <div className="spacer-ask-evans__sidebar-body">
      <div className="spacer-ask-evans__sidebar-label">Briefs</div>

      <div className="spacer-ask-evans__sidebar-list">
        {loading ? (
          <div className="spacer-ask-evans__sidebar-empty">
            <Spin size="small" />
          </div>
        ) : null}

        {!loading && !features.length ? (
          <div className="spacer-ask-evans__sidebar-empty">
            No briefs available for this view.
          </div>
        ) : null}

        {!loading
          ? features.map((f) => {
              const stub = f.status === 'stub';
              const active = f.feature === activeFeature;
              const item = (
                <button
                  key={f.feature}
                  type="button"
                  className={`spacer-ask-evans__sidebar-brief${
                    active ? ' spacer-ask-evans__sidebar-brief--active' : ''
                  }${stub ? ' spacer-ask-evans__sidebar-brief--stub' : ''}`}
                  disabled={stub}
                  title={f.description || f.title}
                  onClick={() => onSelect?.(f.feature)}
                >
                  <span className="spacer-ask-evans__sidebar-item-title">
                    {f.title || f.feature}
                  </span>
                  {f.description ? (
                    <span className="spacer-ask-evans__sidebar-item-meta">{f.description}</span>
                  ) : null}
                  {stub ? (
                    <span className="spacer-ask-evans__sidebar-brief-badge">Soon</span>
                  ) : null}
                </button>
              );
              return stub ? (
                <Tooltip key={f.feature} title="Coming soon" placement="right">
                  {item}
                </Tooltip>
              ) : (
                item
              );
            })
          : null}
      </div>
    </div>
  </aside>
);

export default SpacerLogAiInsightsSidebar;
